import { NCALYER_NOT_CONNECTED, NCALYER_ERROR_ACTION_CANCELED } from '../config/consts';
import { LocaleService } from '@/services/storage.service';
const createCMSSignatureFromBase64 = async function(base64ToSign, storageType) {
    return new Promise(function(resolve) {
        var webSocket = new WebSocket('wss://127.0.0.1:13579/');
        const args = {
            allowedStorages: [storageType],
            data: base64ToSign,
            format: 'cms',
            locale: LocaleService.getLocale(),
            signerParams: {
                extKeyUsageOids: [],
                iin: '',
                bin: '',
                serialNumber: '',
                chain: null
            },
            signingParams: {
                decode: true,
                encapsulate: true,
                digested: false,
                tsaProfile: {}
            }
        };
        webSocket.onopen = function() {
            const sign_data = {
                allowedStorages: [storageType],
                module: 'kz.gov.pki.knca.basics',
                method: 'sign',
                args
            };
            webSocket.send(JSON.stringify(sign_data));
        };

        webSocket.onclose = function(event) {
            if (!event.wasClean) {
                resolve({ status: false, code: NCALYER_NOT_CONNECTED });
            }
        };

        webSocket.onmessage = function(event) {
            var response = JSON.parse(event.data);
            if (Object.prototype.hasOwnProperty.call(response, 'body')) {
                if (!Object.prototype.hasOwnProperty.call(response.body, 'result') && response.status) {
                    // Подписание отклонено пользователем
                    resolve({
                        code: NCALYER_ERROR_ACTION_CANCELED,
                        status: false
                    });
                    webSocket.close();
                }
                // Если возвращается результат и статус, значит всё ок
                else if (response.body.result && Object.prototype.hasOwnProperty.call(response, 'status')) {
                    let responseData = response.body.result[0];
                    responseData = responseData.replace('-----BEGIN CMS-----', '').replace('-----END CMS-----', '');
                    resolve({
                        body: {
                            result: responseData
                        },
                        status: true
                    });
                    webSocket.close();
                }
                // Если имеется код ошибки, выводим пользователю
                else if (response.code) {
                    resolve({
                        status: false,
                        code: response.code,
                        message: response.message
                    });
                    webSocket.close();
                }
            }
        };
    });
};

export { createCMSSignatureFromBase64 };
